"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDynamicField = void 0;
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
const core_1 = require("react-hook-schema/core");
const DynamicFieldInternal = ({ data, schema, schemaComponents, }) => {
    const Field = (0, core_1.createSelector)(schemaComponents);
    const { control, setValue, getValues } = (0, react_hook_form_1.useForm)({
        defaultValues: data,
    });
    (0, react_1.useEffect)(() => {
        const currentValue = getValues();
        for (const key of currentValue ? Object.keys(currentValue) : []) {
            if (!data || !(key in data)) {
                setValue(key, undefined);
            }
        }
        for (const key of data ? Object.keys(data) : []) {
            if (currentValue[key] !== data[key]) {
                setValue(key, data[key]);
            }
        }
    }, [data]);
    return react_1.default.createElement(Field, { control: control, schema: schema });
};
const createDynamicField = (schemaComponents) => {
    return (props) => {
        return (react_1.default.createElement(DynamicFieldInternal, Object.assign({}, props, { schemaComponents: schemaComponents })));
    };
};
exports.createDynamicField = createDynamicField;
